/**
 * Renders all font styles for a given variant including media queries.
 *
 * @param {Object} variant
 *
 * @returns {String}
 */
const renderTypographyStyles = variant => {
  const toKebabCase = str => str.replace(/[A-Z]/g, '-$&').toLowerCase();
  const mediaQueries = {};

  const objectToCss = obj =>
    Object.entries(obj)
      .map(([key, value]) => {
        if (key.startsWith('@')) {
          mediaQueries[key] = value;
          return;
        }

        return `${toKebabCase(key)}: ${value}`;
      })
      .toString()
      .replace(/,/g, ';');

  const mobileCss = objectToCss(variant);

  const mediaQueryCss = Object.entries(mediaQueries)
    .map(([key, value]) => `${key} { ${objectToCss(value)} }`)
    .toString()
    .replace(/,/g, '');

  return mobileCss.concat(mediaQueryCss);
};

export default renderTypographyStyles;
